import { AUTO, Game, Scale, type Types } from 'phaser';
import type { OrbitalBridgeConfig } from '../domain/bridgeLevels';
import { OrbitalBridgeScene } from './OrbitalBridgeScene';

export function startOrbitalBridgeGame(
  parent: string,
  gameId: string,
  bridgeConfig: OrbitalBridgeConfig,
  restartEnabled = true,
): Game {
  const config: Types.Core.GameConfig = {
    type: AUTO,
    width: 1280,
    height: 720,
    parent,
    backgroundColor: '#061126',
    scale: { mode: Scale.ENVELOP, autoCenter: Scale.CENTER_BOTH },
    scene: [new OrbitalBridgeScene(bridgeConfig, gameId, restartEnabled)],
  };
  return new Game(config);
}
